import { invokeApi, GET, PUT } from "./API";

/**
 * Client for the Data Validation endpoints (REV-17124 / REV-17125).
 *
 * Every caller must resolve `properties/recon-errors-enabled` from the org
 * config already in the redux store BEFORE calling these — see
 * `utils/reconErrorsUtils`. A tenant without the flag must issue zero extra
 * requests, so deciding from the response is not good enough.
 */

/**
 * One round trip for the whole page header: a row per failing check, the
 * severity cards and the filter options.
 */
export async function getReconErrorSummary(clientId, filters = {}) {
    return invokeApi(GET, `/private/${clientId}/recon-errors/summary`, {
        queryStringParameters: filters
    });
}

/** One page of records for one check. */
export async function getReconErrorRecords(clientId, params = {}) {
    return invokeApi(GET, `/private/${clientId}/recon-errors`, {
        queryStringParameters: params
    });
}

/** Existence check behind the app-wide banner. */
export async function hasBlockingReconErrors(clientId) {
    return invokeApi(GET, `/private/${clientId}/recon-errors/has-blocking`);
}

/** Blocking count behind the close tile's pre-block. */
export async function getBlockingReconErrorCount(clientId) {
    return invokeApi(GET, `/private/${clientId}/recon-errors/count`);
}

export async function ignoreReconErrors(clientId, items, msg) {
    return invokeApi(PUT, `/private/${clientId}/recon-errors/ignore`, {
        body: { items, msg }
    });
}

/**
 * "Everything matching this filter", not "everything on this page" — the update
 * runs server-side over the filter.
 */
export async function ignoreReconErrorsByFilter(clientId, filter, msg) {
    return invokeApi(PUT, `/private/${clientId}/recon-errors/ignore-all`, {
        body: { filter, msg }
    });
}
